import KGRequest from '@kugou/request/dist/main.js';
import LightMobileCall from '@kugou/light-mobilecall';
import getBaseInfo from '@kugou/get-base-info';

const request = (params, noMobileCall) => {
  if (!noMobileCall) {
    params.useMobileCall = LightMobileCall.isInClient();
  }
  params.isAllowKGAntiBush = params.isAllowKGAntiBush || false;
  return new Promise((resolve) => {
    KGRequest(params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        resolve(err);
      });
  });
};

let baseInfo;
export const initBaseInfo = () => {
  return new Promise((resolve) => {
    if (baseInfo) {
      resolve(baseInfo);
      return;
    }
    getBaseInfo(null, (res) => {
      res.appid = res.appid || 1058;
      baseInfo = res;
      resolve(res);
    });
  });
};

export const checkSingerFollow = async (singerid) => {
  await initBaseInfo();

  const params = {
    plat: baseInfo.plat || '-',
    appid: baseInfo.appid,
  };

  const body = {
    userid: baseInfo.userid || '-',
    singerid,
    token: baseInfo.token || '-',
  };

  return request({
    method: 'POST',
    params,
    data: body,
    sign: 'h5',
    isGateway: false,
    isAllowKGAntiBush: false,
    baseURL: 'https://followservice.kugou.com',
    url: '/v1/checkfollow_wh',
  });
};

export const followSinger = async (singerid) => {
  const baseInfo = await initBaseInfo();
  const params = {
    userid: baseInfo.userid || '-',
    singerid,
    token: baseInfo.token || '-',
    appid: baseInfo.appid,
  };

  return request({
    method: 'GET',
    params,
    sign: 'h5',
    isGateway: false,
    baseURL: 'https://followservice.kugou.com',
    url: '/v1/follow',
  });
};

export const unfollowSinger = async (singerid) => {
  const baseInfo = await initBaseInfo();
  const params = {
    userid: baseInfo.userid || '-',
    singerid,
    token: baseInfo.token || '-',
    appid: baseInfo.appid,
  };

  return request({
    method: 'GET',
    params,
    sign: 'h5',
    isGateway: false,
    baseURL: 'https://followservice.kugou.com',
    url: '/v1/unfollow',
  });
};

export const fetchSong = async (singerid) => {
  const baseInfo = await initBaseInfo();
  const params = {
    userid: baseInfo.userid || 0,
    token: baseInfo.token || '',
    pageidx: 1,
    pagesize: 50,
    appid: baseInfo.appid,
    mid: baseInfo.mid,
  };

  return request({
    method: 'GET',
    params,
    sign: 'h5',
    isGateway: false,
    isAllowKGAntiBush: true,
    baseURL: 'https://h5activity.kugou.com',
    url: '/v1/musician/xingyao_succ_songs',
  });
};